(function (window, document) {
  'use strict';

  var P = window.Printara;
  if (!P) return;

  var STANDARD_MEDIA_ALLOWANCE = 0.5;
  var CONTOUR_CUT_MEDIA_ALLOWANCE = 2;
  var lastContourState = null;


function indicatesContourCut(value) {
  var text = P.util.normalizeText(value);

  // Exclude "No Contour Cut" even when extra text follows it,
  // such as Shopify's "Variant sold out or unavailable" label.
  if (/\b(?:no|without)\s+contour[\s-]*cut\b/.test(text)) {
    return false;
  }

  return (
    /\bcontour[\s-]*cut\b/.test(text) &&
    !/\b(?:no|without)\s+contour[\s-]*cut\b/.test(text)
  );
}


  function labelText(input) {
    if (!input) return '';

    if (input.id) {
      var label = document.querySelector(
        'label[for="' + String(input.id).replace(/"/g, '\\"') + '"]'
      );

      if (label) return label.textContent || '';
    }

    var parentLabel = input.closest && input.closest('label');
    if (parentLabel) return parentLabel.textContent || '';

    var field =
      input.closest &&
      input.closest('.wcpa_field_wrap, .wcpa_form_item, .wcpa_row, .wcpa_wrap');

    return field ? field.textContent || '' : '';
  }

  function explicitContourSelected() {
    var controls = document.querySelectorAll(
      '[data-printara-contour-cut], [data-gk-contour-cut]'
    );

    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];

      if (control.matches('input[type="checkbox"], input[type="radio"]')) {
        if (control.checked) return true;
        continue;
      }

      if (control.matches('select')) {
        var option = control.options[control.selectedIndex];

        if (
          indicatesContourCut(control.value) ||
          indicatesContourCut(option && option.textContent)
        ) {
          return true;
        }

        continue;
      }

      if (indicatesContourCut(control.value || control.textContent)) {
        return true;
      }
    }

    return false;
  }


function fallbackContourSelected() {
  var checked = document.querySelectorAll(
    'input[type="checkbox"]:checked, input[type="radio"]:checked'
  );

  for (var i = 0; i < checked.length; i += 1) {
    var input = checked[i];

    // Let the Shopify variant detector handle variant options.
    if (
      input.closest &&
      input.closest('.wcpa_form_outer, .aco_addon_wrapper') === null &&
      (
        (input.name || '').indexOf('options[') === 0 ||
        input.name === 'Cutting & Finishing'
      )
    ) {
      continue;
    }

    var label = labelText(input).trim();

    // Prefer the visible label when available.
    var text = label || input.value || 
      (input.dataset && input.dataset.value) || '';

    if (indicatesContourCut(text)) {
      return true;
    }
  }

  var selects = document.querySelectorAll('select');

  for (var j = 0; j < selects.length; j += 1) {
    var select = selects[j];

    if (
      select.closest &&
      select.closest('[data-gk-calc]')
    ) {
      continue;
    }

    // Shopify variants are handled separately.
    if (
      (select.name || '').indexOf('options[') === 0 ||
      select.name === 'id'
    ) {
      continue;
    }

    var selected = select.options[select.selectedIndex];

    // Prefer the displayed selected option over the underlying value.
    var selectedText = selected && selected.textContent
      ? selected.textContent.trim()
      : '';

    var text = selectedText || select.value || '';

    if (indicatesContourCut(text)) {
      return true;
    }
  }

  return false;
}



  function variantContourSelected() {
    // Shopify product option dropdowns.
    var selects = document.querySelectorAll(
      'select[name^="options["], select[name="id"]'
    );

    for (var i = 0; i < selects.length; i += 1) {
      var select = selects[i];

      // Ignore selectors belonging to the product-options app.
      if (
        select.closest &&
        select.closest('.wcpa_form_outer, .aco_addon_wrapper, [data-gk-calc]')
      ) {
        continue;
      }

      var option = select.options[select.selectedIndex];

      if (
        indicatesContourCut(select.value) ||
        indicatesContourCut(option && option.textContent)
      ) {
        return true;
      }
    }

    // Shopify product option radio buttons.
    var radios = document.querySelectorAll(
      'input[type="radio"]:checked'
    );

    for (var j = 0; j < radios.length; j += 1) {
      var radio = radios[j];

      if (
        radio.closest &&
        radio.closest('.wcpa_form_outer, .aco_addon_wrapper, [data-gk-calc]')
      ) {
        continue;
      }

      var name = radio.name || '';

      // Only consider Shopify variant option controls.
      if (
        name.indexOf('options[') === 0 ||
        name === 'Cutting & Finishing'
      ) {
        if (
          indicatesContourCut(radio.value) ||
          indicatesContourCut(labelText(radio))
        ) {
          return true;
        }
      }
    }

    return false;
  }

  function isContourCutSelected() {
    return explicitContourSelected() ||
      fallbackContourSelected() ||
      variantContourSelected();
  }

  
console.log('Contour cut diagnostic:', {
  appOption: explicitContourSelected(),
  fallbackOption: fallbackContourSelected(),
  productVariant: variantContourSelected(),
  finalContourState: isContourCutSelected(),
  mediaAllowance: getMediaAllowance(),
  usableWidth: getUsableMediaWidth(48)
});


  function getMediaAllowance() {
    return isContourCutSelected()
      ? CONTOUR_CUT_MEDIA_ALLOWANCE
      : STANDARD_MEDIA_ALLOWANCE;
  }

  function getUsableMediaWidth(mediaWidth) {
    var width = Number(mediaWidth);

    if (!isFinite(width) || width <= 0) return 0;

    return Math.max(0, width - getMediaAllowance());
  }

  function publishIfChanged() {
    var current = isContourCutSelected();

    if (lastContourState === null) {
      lastContourState = current;
      return;
    }

    if (current === lastContourState) return;

    lastContourState = current;

    P.emit('printara:production-options:update', {
      contourCut: current,
      mediaAllowance: getMediaAllowance()
    });
  }

  function init() {
    lastContourState = isContourCutSelected();

    document.addEventListener('change', function () {
      window.setTimeout(publishIfChanged, 0);
    });

    document.addEventListener('input', function () {
      window.setTimeout(publishIfChanged, 0);
    });

    var root =
      document.querySelector('.wcpa_form_outer') ||
      document.querySelector('.aco_addon_wrapper');

    if (root) {
      var timer;

      new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(publishIfChanged, 20);
      }).observe(root, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }

  P.productionOptions = {
    STANDARD_MEDIA_ALLOWANCE: STANDARD_MEDIA_ALLOWANCE,
    CONTOUR_CUT_MEDIA_ALLOWANCE: CONTOUR_CUT_MEDIA_ALLOWANCE,
    isContourCutSelected: isContourCutSelected,
    getMediaAllowance: getMediaAllowance,
    getUsableMediaWidth: getUsableMediaWidth
  };

  P.util.ready(init);
})(window, document);
